import React, { useState } from "react";
import { getUsoImagen, Image } from "../../types/image";
import { Product } from "../../types/product";
//import Swal from "sweetalert2";
import { formatDate } from "../../utils/fechaUtil";
import { UsoImagenType/*, USO_IMAGEN*/, USO_IMAGEN_LABELS } from "../../types/image";



interface ImageGalleryProps {
    images: Image[];
    product: Product;
    onImageDelete: (image: string) => Promise<void>;
    loading?: boolean;
    onImageUsoChange: (imageName: string, usoImagen: UsoImagenType) => Promise<void>;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({ images, product, onImageDelete, loading = false, onImageUsoChange }) => {
    const [selectedImage, setSelectedImage] = useState<Image | null>(null);
    // Generar un timestamp único al cargar el componente
    const cacheBuster = Date.now();

    //const [deleting, setDeleting] = useState<string | null>(null);
    

    /* const handleDeleteImage = async (imageName: string) => {
        const result = await Swal.fire({
            title: '¿Está seguro?',
            text: `Se eliminará la imagen seleccionada del producto ${product.productCode}. Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) {
            await Swal.fire({
                icon: 'info',
                title: 'Acción cancelada',
                toast: true,
                position: 'bottom',
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true
            });
            return;
        }

        setDeleting(imageName);

        try {
            //borrar la imagen
            await onImageDelete(imageName);
            //Swal.fire('Eliminada', 'La imagen ha sido eliminada.', 'success');
        } catch (error) {
            console.error('Error eliminando imagen: ', error);
        }
        finally {
            setDeleting(null);
        }
    }; */

    const formatFileSize = (sizeInBytes: number): string => {
        if (sizeInBytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(sizeInBytes) / Math.log(k));
        return parseFloat((sizeInBytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };


    if (loading) {
        return (
            <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Cargando imágenes...</span>
                </div>
                <p className="mt-2 text-muted">Cargando imágenes desde el bucket...</p>
            </div>
        );
    }

    if (images.length === 0) {
        return (
            <div className="text-center py-5">
                <i className="bi bi-images display-4 text-muted"></i>
                <p className="mt-2 text-muted">No se encontraron imágenes para el producto {product.productCode}</p>
                <p className="text-muted">Utilice el área de carga para agregar nuevas imágenes.</p>
            </div>
        );
    }

    return (
        <div>
            <h5 className="mb-3">Imágenes existentes ({images.length})</h5>

            <div className="row g-3">
                {images.map((image, index) => { 
                    const imageUrl = `${image.url}?v=${cacheBuster}`;
                    return (                    
                    <div key={index} className="col-sm-6 col-md-4 col-lg-3">
                        <div className="card h-100">
                            <div className="position-relative">
                                <img
                                    //src={image.url}
                                    src={imageUrl}
                                    className="card-img-top"
                                    title={`${image.name}`}
                                    alt={`Imagen ${index + 1} de ${product.productCode}`}
                                    style={{ height: '150px', objectFit: 'cover', cursor: 'pointer' }}
                                    onClick={() => setSelectedImage(image)}
                                    loading="lazy"
                                />
                                <select
                                    value={getUsoImagen(image)}
                                    /*onChange={(e) => handleUsoImagenChange(e.target.value as UsoImagenType, image)}*/
                                    onChange={(e) => onImageUsoChange(image.name, e.target.value as UsoImagenType)}
                                >
                                    {Object.entries(USO_IMAGEN_LABELS).map(([key, label]) => (
                                        <option key={key} value={key}>
                                            {label}
                                        </option>
                                    ))}
                                </select>
                                {/* {deleting === image.name && (
                                    <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center">
                                        <div className="spinner-border text-white" role="status">
                                            <span className="visually-hidden">Eliminando...</span>
                                        </div>
                                    </div>
                                )} */}
                                {/* {usoImageChanging === image.name && (
                                    <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center">
                                        <div className="spinner-border text-white" role="status">   
                                            <span className="visually-hidden">Cambiando uso...</span>
                                        </div>
                                    </div>
                                )} */}
                            </div>

                            <div className="card-body d-flex flex-column">
                                <h6 className="card-title text-truncate">{image.name}</h6>
                                <div className="mt-auto">
                                    <div className="d-flex flex-wrap gap-1 align-items-center">
                                        <span className="badge bg-secondary">{formatFileSize(image.size)}</span>
                                    </div>
                                    <div className="mt-2">
                                        <small className="text-muted d-block" style={{ lineHeight: '1.2' }}>
                                            Modificado: {formatDate(image.lastModified)}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div className="card-footer bg-transparent pt-2 pb-2">
                                <div className="btn-group w-100" role="group">
                                    {/* <button
                                        className={`btn bt-sm ${mainImageName === image.name ? 'btn-success' : 'btn-outline-success'}`}
                                        onClick={() => handleSetMainImage(image.name, image.url)}
                                        disabled={settingMain === image.name || mainImageName === image.name}
                                        title={mainImageName === image.name ? 'Image principal ' : 'Establecer como principal '}
                                    >
                                        {settingMain === image.name ? (
                                            <span className="spinner-border spinner-border-sm" />
                                        ) : mainImageName === image.name ? (
                                            <i className="bi bi-star-fill" />
                                        ) : (
                                            <i className="bi bi-star" />
                                        )}
                                    </button> */}
                                    <a
                                        href={imageUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-primary btn-sm"
                                        title="Ver Imagen Completa"
                                    >
                                        <i className="bi bi-box-arrow-up-right"></i>
                                    </a>
                                    <button
                                        onClick={() => onImageDelete(image.name)}
                                        /*disabled={deleting === image.name}*/
                                        className="btn btn-outline-danger btn-sm"
                                        title="Elminar Imagen"
                                    >
                                        {/* {deleting === image.name ? (
                                            <span className="spinner-border spinner-border-sm" role="status"></span>
                                        ) : (
                                            <i className="bi bi-trash"></i>
                                        )} */}
                                        <i className="bi bi-trash"></i>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                )})}
            </div>

            {selectedImage && (
                <div className="modal show d-block" tabIndex={-1} onClick={() => setSelectedImage(null)} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content" onClick={e => e.stopPropagation()}>
                            <div className="modal-header">
                                <h5 className="modal-title text-truncate">{selectedImage.name}</h5>
                                <button type="button" className="btn-close" onClick={() => setSelectedImage(null)}></button>
                            </div>
                            <div className="modal-body text-center">
                                <img src={selectedImage.url} alt="Vista previa" className="img-fluid" style={{ maxHeight: '70vh', objectFit: 'contain' }} />
                                <div className="mt-3">
                                    <small className="text-muted">
                                        Tamaño: {formatFileSize(selectedImage.size)} |
                                        Modificado: {formatDate(selectedImage.lastModified)}
                                    </small>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <a
                                    href={selectedImage.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary"
                                >
                                    <i className="bi bi-download me-2"></i>Descargar
                                </a>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setSelectedImage(null)}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default ImageGallery;